import styled from 'styled-components'
import { media } from '../../../../utils/styles'
import NxHeading from '../../../../components/heading/NxHeading'
import { NxText } from '../../../../components/text'

export const Container = styled.main`
  height: 100dvh;
  display: flex;
  align-items: center;
`

export const Content = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 var(--spacing-size-3xl);

  ${media.laptop`
    flex-direction: column;
    padding: 0 var(--spacing-size-xl);
    gap: var(--spacing-size-xs);
    align-items: center;
  `}

  ${media.tablet`
    padding: 0;
  `}
`

export const Brand = styled.section`
  display: flex;
  align-items: center;

  ${media.tablet`
    flex-direction: column;
  `}
`

export const BrandName = styled(NxHeading)`
  margin-left: var(--spacing-size-md);

  ${media.tablet`
    display: block;
    margin: var(--spacing-size-xs) 0 0;
  `}
`

export const LoginBox = styled.section`
  width: 360px;
  box-shadow: var(--shadow-level-2) rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  padding: 24px;

  ${media.tablet`
    max-width: 360px;
    width: 80dvw;
    margin: auto;
  `}

  & > button {
    display: grid;
    width: 100%;
  }

  & > button:first-of-type {
    margin-bottom: var(--spacing-size-3xs);
  }
`

export const LoginTitle = styled.div`
  display: flex;
`

export const LoginTitleIcon = styled.span`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  border-radius: var(--border-radius-sm);
  transition: background-color 0.275s var(--vibe-soft);

  &:hover {
    background-color: var(--color-action-hover);
  }
`

export const LoginSubtitle = styled(NxText)`
  margin: 2px 0 var(--spacing-size-xs);
  display: block;
`

export const Footer = styled.footer`
  height: 2rem;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: var(--color-brand-300);
`
